__webpack_require__.p = "https://devapp.sportkompas.be/";